import { useApiClient } from '@m43/core';
import { useEnabledFeatures } from '../../common/hooks/enabled-features/use-enabled-features';
import { DispositionResource } from '@mark43/cad-api';
import { useQuery } from '@tanstack/react-query';

export function useDispositionQuery({ agencyEventId }: { agencyEventId?: number }) {
    const { unitLevelDispositionsEnabled } = useEnabledFeatures();
    const apiClient = useApiClient();

    const query = useQuery({
        queryKey: ['disposition', agencyEventId],
        queryFn() {
            if (agencyEventId) {
                return apiClient
                    .request<DispositionResource.BootstrapDispositionsModal>({
                        method: 'POST',
                        url: 'disposition/bootstrap',
                        data: { agencyEventId },
                    })
                    .then((res) => {
                        return res.data.data;
                    });
            }
        },
        enabled: unitLevelDispositionsEnabled,
    });

    return query;
}
